<template>
  <div class="container">
    <section class="article-search">
      <div class="search-wapper">
        <h3>
          <span>—</span>{{ !sysName || sysName === "null" ? "外文学术资源数据库" : sysName }}
          <span>—</span>
        </h3>
        <div class="search flex">
          <div>
            <div class="flex search_div">
              <el-select class="title-select" v-model="search.selectVal" placeholder="请选择" @change="handleChangeSelect">
                <el-option v-for="item in search.searchPaperOptions" :key="item.autoCompletionFieldName" :label="item.showName" :value="item.autoCompletionFieldName"></el-option>
              </el-select>
              <!-- <el-select v-model="search.value" @change="handleChangeSelect" class="title-select" placeholder="请选择">
                <el-option v-for="item in search.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select> -->
              <div class="searchLeft flex">
                <div class="inputDiv flex">
                  <el-input v-model="search.keyword" clearable maxlength="1000" @keyup.enter.native="toSearch" @click.stop.native="getInputFocus" :placeholder="placeholderName()"></el-input>
                  <!-- <el-input v-model="search.keyword" clearable maxlength="1000" @keyup.enter.native="toSearch" @click.stop.native="getInputFocus" :placeholder="placeholderName()"></el-input> -->
                  <div @click="toSearch" class="search-btn" :class="{ default: heightFlag }">
                    <img src="../../assets/images/icon-js.png" />
                  </div>
                </div>
                <!-- 输入联想弹出层 -->
                <!-- <div class="search-input" v-if="search.searchFlag && search.selectVal != 'language' && search.selectVal != 'issn' && search.selectVal != 'doi'">
                  <ul>
                    <li class="line1" v-for="(item, index) in search.keywordDataList" :key="index" @click="toSearchKeyword(index)" v-html="item.suggestionWord"></li>
                  </ul>
                </div> -->
                <!-- 语种特殊处理 -->
                <div class="search-input" v-if="search.searchFlag && search.selectVal == 'language'">
                  <ul>
                    <li v-for="(item, index) in languageList" :key="index" @click="toSearchKeyword(index)">
                      {{ item.suggestionWord }}
                    </li>
                  </ul>
                </div>
              </div>
              <a @click="handleHeightSearch">高级检索</a>

              <!-- 高级检索弹出层 -->
              <div class="search-height" v-if="heightFlag">
                <div v-for="(item, index) in heightListData" :key="index" class="flex">
                  <el-select class="opera" v-model="item.operation" placeholder="请选择">
                    <el-option v-for="element in operationList" :key="element.value" :label="element.label" :value="element.value"> </el-option>
                  </el-select>
                  <el-select class="field" v-model="item.searchField" placeholder="请选择">
                    <el-option v-for="element in articleList" :key="element.value" :label="element.label" :value="element.value"> </el-option>
                  </el-select>
                  <el-input v-model="item.searchWords" placeholder="请输入要检索的内容" clearable></el-input>
                  <i class="el-icon-minus" @click="remove(index)"></i>
                </div>
                <div class="time-height" v-if="publiserDateFlag">
                  <el-date-picker v-model="publishYearStart" :picker-options="pickerYearStart" value-format="yyyy" type="year" placeholder="出版起始时间"> </el-date-picker>
                  <span>至</span>
                  <el-date-picker v-model="publishYearEnd" :picker-options="pickerYearEnd" value-format="yyyy" type="year" placeholder="出版截止时间"> </el-date-picker>
                  <i class="el-icon-minus" @click="removePublisherDate"></i>
                </div>
                <div class="subject-height" v-if="subjectFlag">
                  <el-select class="selectVal" v-model="subjectWords" clearable placeholder="请选择学科">
                    <el-option v-for="element in subjcetList" :key="element.id" :label="element.subjectName" :value="element.id + '+' + element.subjectName"> </el-option>
                  </el-select>
                  <i class="el-icon-minus" @click="removeSubject"></i>
                </div>
                <div class="btns-height">
                  <span @click="addSearch">添加检索条件</span>
                  <span @click="addPubliserDate" v-if="!publiserDateFlag">添加出版时间</span>
                  <span @click="addSubject" v-if="!subjectFlag">添加学科</span>
                  <div class="btns">
                    <el-button type="info" @click="toReset">重置</el-button>
                    <el-button type="primary" @click="handleHeightSearchEvent">搜索</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search_nav">当前位置：首页 > <span>文章</span></div>
      </div>
    </section>

    <section class="w1580 flex">
      <left-menu
        ref="leftMenuRef"
        v-loading="leftLoading"
        :leftData="leftData"
        :showLetterFlag="showLetter"
        :delName="delName"
        :delSourceFrom="delSource"
        :delAll="delAll"
        :preSelectedSubject="preSelectedSubject"
        @childByValue="childByValue"
        @sourceByValue="sourceByValue"
        @clearPreSelectedSubject="clearPreSelectedSubject"
      ></left-menu>
      <!-- 中间列表 -->
      <div class="right-list">
        <div class="right-top">
          <p class="filter" v-if="search.keyword || searchArray.length > 0 || publishYearStart">
            <span class="searchword" v-if="search.keyword">
              检索结果：“<label class="red">{{ search.searchData }}</label
              >”（<label class="red">{{ listTotal }}</label
              >条记录）
            </span>

            <span class="searchword" v-if="searchArray.length > 0 || publishYearStart">
              高级检索条件："
              <label v-for="(item, index) in searchArray" :key="index"
                >{{
                  item.searchField == "title"
                    ? "题名"
                    : item.searchField == "author"
                    ? "作者"
                    : item.searchField == "author1"
                    ? "第一作者"
                    : item.searchField == "journalName"
                    ? "来源出版物名称"
                    : item.searchField == "digest"
                    ? "摘要"
                    : item.searchField == "hingeWord"
                    ? "关键词"
                    : item.searchField == "language.raw"
                    ? "语种"
                    : item.searchField == "issn"
                    ? "ISSN"
                    : item.searchField == "authorOrg"
                    ? "归属机构"
                    : item.searchField == "secondSubject"
                    ? "学科"
                    : "赞助基金"
                }}：{{ item.searchVal ? item.searchLabel : item.searchWords }}{{ index + 1 < searchArray.length ? "," : "" }}
              </label>
              <label v-if="publishYearStart && publishYearEnd">{{ searchArray.length > 0 ? "," : "" }}出版时间：{{ publishYearStart }} - {{ publishYearEnd }}</label>

              "
            </span>
          </p>
          <div class="filter">
            筛选条件：
            <label v-for="(item, index) in sourceList" :key="index" class="flex">
              资源来源:
              {{ item == 1 ? "加入馆外资源更多结果" : "开放获取资源" }}
              <i class="el-icon-close" @click="handleDelSource(item)"></i>
            </label>
            <!-- 只在左侧菜单还没有加载学科筛选条件时显示预选中的学科 -->
            <label v-if="preSelectedSubject && preSelectedSubject.id && !hasSubjectInConData" class="flex">
              外文学科: {{ preSelectedSubject.name }}
              <i class="el-icon-close" @click="handleDelSubject()"></i>
            </label>
            <label v-for="(item, index) in conData" :key="index" class="flex">
              {{ item.fatherName }}: {{ item.name }}
              <i class="el-icon-close" @click="handleDelName(item)"></i>
            </label>
            <label v-if="hasActiveFilters" class="clear-all flex" @click="clearAllFilters">
              清空全部
              <i class="el-icon-close"></i>
            </label>
          </div>
        </div>
        <div class="right-item" v-loading="loading">
          <!-- <p>
            排序：
            <el-select v-model="sortVal" @change="handleSearchSort" placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </p> -->
          <div class="sort-item">
            <p v-for="(item, index) in sortList" :class="{ checked: sortIndex == index }" :key="index" @click="handleChangeSort(index)">
              {{ item.label }}
            </p>
            <!-- 分页按钮 -->
            <div class="pagination-controls">
              <button class="page-btn prev-btn" @click="handlePrevPage" :disabled="pageNo <= 1">
                <i class="el-icon-arrow-left"></i>
              </button>
              <span class="page-info">{{ pageNo }}/{{ Math.ceil(total / pageSize) }}</span>
              <button class="page-btn next-btn" @click="handleNextPage" :disabled="pageNo >= Math.ceil(total / pageSize)">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>
          <ul>
            <li class="flex" v-for="(item, index) in list" :key="index">
              <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
              <div class="right-info">
                <p @click="toDetail(index)">
                  <span class="read_tag" v-if="item.visited">已读</span><span v-html="item.title"></span>
                  <img v-if="item.source == '馆藏资源'" src="../../assets/images/icon-gc.png" />
                  <!-- <label
                    :class="getColor(item.oaType)"
                    v-html="getoatext(item.oaType)"
                  ></label> -->
                </p>
                <p v-if="item.authorArray && item.authorArray.length > 0">
                  作者：<span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                    <span class="span_a" @click="toAuthorDetail(element)" v-html="element.authorName"></span>
                    <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                    <div class="author-content">
                      <p class="mb10" v-html="element.authorName"></p>
                      <p>
                        <span v-if="element.hindex != null"
                          >hindex：<label>{{ element.hindex }}</label></span
                        >
                        <span v-if="element.i10Index != null"
                          >i10Index：<label>{{ element.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span v-if="element.citedByCount != null"
                          >citedByCount：<label>{{ element.citedByCount }}</label></span
                        >
                        <span v-if="element.worksCount != null"
                          >worksCount：<label>{{ element.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                    </div>
                  </span>
                  <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
                  <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
                </p>
                <p v-if="item.journalName">
                  期刊信息：<span @click="toHomeDetail(item)"> <span class="undline" v-html="item.journalName"></span>; </span>
                  <label v-if="item.year">{{ item.year }} ; </label>
                  {{ item.volume }}
                  <label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
                </p>
                <p v-if="item.publishDate">出版时间：<span v-html="item.publishDate"></span></p>
                <p v-if="item.doi">DOI：<span v-html="item.doi"></span></p>
                <p v-if="item.hingeWord">
                  关键词：
                  <span class="fenhao" v-for="(element, idx) in item.hingeWordArray" :key="idx" @click="searchWords(element)">
                    <label class="green" v-html="element"></label>
                    <label v-if="idx < item.hingeWordArray.length - 1">;</label>
                  </span>
                </p>
                <!-- <p v-if="item.publisherName">出版社: {{ item.publisherName }}</p> -->
                <p v-if="item.digest && !item.open">摘要：<span :title="item.digestAll" v-html="capitalize(item.digest)"></span></p>
                <!-- <p v-if="item.digest && item.open">
                  摘要 ：<span v-html="item.digest"></span>
                  <label class="digestLabel" @click="closeDigest(index)">收起</label>
                </p> -->

                <!-- <p v-if="item.source">来源：{{ item.source }}</p> -->
                <div class="btn-p flex">
                  <p class="num-tips">
                    引用量<span>{{ item.citedCount }}</span>
                  </p>
                  <div class="btn-right">
                    <div @click.stop class="flex">
                      <div class="btn article-action-active" v-if="roles && item.gainLiteratureState === true && item.source !== '商业资源'" @click="getResource(item, index)" :class="{ noCourse: item.btnLoading }">
                        <img class="rotating-image" v-if="item.btnLoading" src="../../assets/images/loading_s.svg" />
                        <img class="img" src="../../assets/images/icon-qwhq-mr.png" />
                        <img class="hover-img" src="../../assets/images/icon-qwhq-xz.png" />全文获取
                      </div>
                      <div class="achieve" v-if="Resourcelist == item.openAlexId" v-loading="achieveloading" ref="showPanel">
                        <div class="achieve-li">
                          <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                            <a v-html="bookitem.shortName" @click="libdetailUrl(item, bookitem)"></a>
                          </li>
                          <li v-if="gainResource.provideType == '3'" @click="recommendrecord(item)">
                            <a>推荐</a>
                          </li>
                          <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(item)">
                            <a>单篇采选</a>
                          </li>
                          <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(item)">
                            <a>文献传递</a>
                          </li>
                          <li v-if="gainResource.provideType == '5'" @click="getLiterature(item)">
                            <a>请求获取</a>
                          </li>
                          <li v-if="paperData.baiduXueShuExist">
                            <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                          </li>
                          <li v-if="qingqiuhuoqu">
                            <a @click="getQingqiu(item)">请求获取</a>
                            <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                          </li>
                          <!-- <ul v-if="gainResource.provideType == '1'">
                            <li v-for="(wxitem, index) in remmendlist" :key="index">
                              <a v-if="wxitem.name != '文献获取'" v-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <a v-if="wxitem.name == '文献获取' && item.doi" v-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <span v-if="wxitem.name == '文献获取'"><i class="el-alert__icon el-icon-warning"></i>一般十分钟获取全文</span>
                              <span v-if="wxitem.name == '百度学术'"><i class="el-alert__icon el-icon-warning"></i>每天免费申请两次</span>
                            </li>
                          </ul> -->
                        </div>
                      </div>
                    </div>
                    <div class="flex article-action-active" @click="copylist(item.sid)">
                      <img src="../../assets/images/icon-fz-mr.png" class="img" />
                      <img src="../../assets/images/icon-fz.png" class="hover-img" />复制
                    </div>
                    <div class="flex article-action-active" @click="showReference(item)">
                      <img class="img" src="../../assets/images/icon-yy-mr.png" />
                      <img class="hover-img" src="../../assets/images/icon-yy-xz.png" />引用
                    </div>
                    <!-- <div
                      class="flex"
                      :class="{ checked: item.share }"
                      @click="isCollect(item)"
                      v-if="!info.ipUser"
                    >
                      <img
                        class="img"
                        :src="item.share ? collectTrue : collectFalse"
                      />
                      <img
                        class="hover-img"
                        src="../../assets/images/icon-sc-xz.png"
                      />收藏
                      <i class="share" v-if="item.shareCount > 0">{{
                        item.shareCount
                      }}</i>
                    </div> -->
                    <div class="flex collect-action" :class="{ checked: item.share }" @click="getFolderList(item.sid, item.share)" v-if="!info.ipUser">
                      <img class="img" :src="item.share ? collectTrue : collectFalse" />
                      <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />{{ item.share ? "已收藏" : "收藏" }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="noData" v-if="total <= 0">
            <img src="../../assets/images/noData.png" />
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
        </div>
      </div>
      <!-- 右侧相关话题 -->
      <div class="topicList" v-if="total > 0 && topicList && topicList.length > 0">
        <h3>相关话题</h3>
        <el-switch @change="changeCn" v-model="cnFlag" active-text="中文" inactive-text="English" style="margin: 20px 0px 0px 20px"></el-switch>
        <ul v-loading="topicLoading">
          <li v-for="(item, index) in topicList" :key="index" @click="toTopicDetail(item)">
            <p class="line2" :title="cnFlag ? item.zhName : item.topicName">
              {{ cnFlag ? item.zhName : item.topicName }}
            </p>
            <p class="line2" :title="cnFlag ? item.zhDescription : item.description">描述：{{ cnFlag ? item.zhDescription : item.description }}</p>
          </li>
        </ul>
      </div>
    </section>
    <state-dialog :stateVal="state" :dialogVisible="stateDialogVisible" :bodyItemDialog="bodyItem" @closeDialog="closeDialog"></state-dialog>
    <el-dialog title="引用" :visible.sync="referenceDialog" width="30%">
      <div class="dialog-content">
        <ul class="dialog-tab">
          <li @click="changeDialogTab(1)" :class="{ dialogChecked: dialogIndex == 1 }">BIB</li>
          <li @click="changeDialogTab(2)" :class="{ dialogChecked: dialogIndex == 2 }">CITE</li>
        </ul>
        <div class="tab1" v-if="dialogIndex == 1">
          <ul>
            <li>
              <p class="flex">
                <span @click="copyContent(BIBObj)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">{{ BIBObj }}</div>
            </li>
          </ul>
        </div>
        <div class="tab1" v-if="dialogIndex == 2">
          <ul>
            <li v-for="(item, index) in CITEArray" :key="index">
              <p class="flex line">
                <label>{{ item.name }}</label>
                <span @click="copyContent(item.value)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="down-dialog-footer">
        导出为
        <span @click="handleExport('bib')">BibTex</span>
        <span @click="handleExport('endnote')">EndNote</span>
      </span>
    </el-dialog>

    <el-dialog title="收藏" :visible.sync="addFodlerDialog" width="25%" class="add_folder_dialog">
      <div class="add_dialog_folder" ref="myScroll">
        <ul>
          <li v-for="(item, index) in folderList" :key="index">
            <div class="div_folder li_folder" v-if="!item.addFlag" @click="handleChoiseFolder(index)">
              <div><img src="../../assets/images/icon-wjj-mr.png" />{{ item.name }}</div>
              <!-- <span v-if="item.exist">已存在</span> -->
              <i class="el-icon-check" v-if="folderIndex === index || (!checkFolder && item.exist)"></i>
            </div>
            <div class="div_folder new_folder" v-else>
              <img src="../../assets/images/icon-wjj-xz.png" alt="" />
              <el-input placeholder="请输入文件夹名称" v-model="item.name" maxlength="20" @keyup.enter.native="submitAddFolder($event)"></el-input>
              <span @click.stop="cannalFolder()"><i class="el-icon-close"></i></span>
              <span><i class="el-icon-check" @click.stop="submitAddFolder($event)"></i></span>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <p @click="newAddFolder"><i class="el-icon-folder-add"></i>新建文件夹</p>
        <div>
          <el-button @click="addFodlerDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitFolder">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="25%">
      <el-input placeholder="请输入手机号" v-model="phone" maxlength="20" @keyup.enter.native="submitAddphone($event)" class="phone-input"></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="420px" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>

        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
import PublicSearch from "@/components/public_search.vue";
import LeftMenu from "@/components/leftMenu.vue";
import StateDialog from "@/components/state_dialog.vue";
import { oaColor } from "../../assets/js/oacolor";
import { oaText } from "../../assets/js/oacolor";
import Axios from "axios";

export default {
  name: "Article",
  components: { PublicSearch, LeftMenu, StateDialog },
  data() {
    return {
      loading: true,
      leftLoading: false,
      achieveloading: true,
      conData: [], //条件的过滤
      filterData: [],
      shouldRefreshLeftAfterFilterDelete: false,
      leftData: [],
      list: [],
      showLetter: false, //左侧聚合是否显示首字母
      delName: null,
      delAll: 0,
      pageSize: 10,
      pageNo: 1,
      listTotal: 0,
      total: 0,
      state: 0,
      stateDialogVisible: false,
      bodyItem: null,
      searchArray: [],
      roles: true,
      sourceList: [],
      delSource: 0,
      Resourcelist: false,
      remmend: false,
      remmendlist: [],
      detaildoi: "",
      search: {
        value: 1,
        options: [
          {
            value: 1,
            label: "分词检索",
          },
          {
            value: 2,
            label: "智能检索",
          },
        ],
        searchPaperOptions: [],
        selectVal: "",
        keyword: "",
        searchData: "",
        searchFlag: false, //联想层 是否显示
        keywordDataList: [],
      },
      sortList: [
        {
          value: "publishDate",
          label: "出版时间",
        },
        {
          value: "_score",
          label: "相关度",
        },
        {
          value: "citedCount",
          label: "引用量",
        },
      ],
      sortIndex: 1,
      sortVal: "_score",
      liblist: [],
      Paperstate: "",
      gainResource: {},
      operationList: [
        {
          value: "1",
          label: "与",
        },
        {
          value: "2",
          label: "或",
        },
      ],
      articleList: [],
      heightListData: [
        {
          searchField: "title",
          searchWords: "",
          operation: "1",
        },
      ],
      subjcetList: [],
      value1: "",

      publiserDateFlag: false,
      subjectFlag: false, //学科标识
      heightFlag: false, //高级检索标识
      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
      subjectWords: "", //学科model
      publishYearStart: null,
      publishYearEnd: null,
      pickerYearStart: {
        disabledDate: time => {
          if (this.publishYearEnd) {
            return time.getFullYear() > this.publishYearEnd;
          }
        },
      },
      pickerYearEnd: {
        disabledDate: time => {
          if (this.publishYearStart) {
            return time.getFullYear() < this.publishYearStart;
          }
        },
      },
      referenceDialog: false,
      dialogIndex: 1,
      BIBObj: null,
      CITEArray: [],
      exportSid: "",

      languageList: [], //语种下拉列表

      qingqiuhuoqu: false, //显示请求获取
      // 相关话题
      topicList: [],
      noTopicData: false,
      topicLoading: false,

      info: null,
      //文件夹
      addFodlerDialog: false,
      folderList: [],
      folderIndex: null,
      checkFolder: false,
      foldershare: false,
      cnFlag: false,
      preSelectedSubject: null, // 存储预选中的学科信息
      phoneDialog: false,
      show: true,
      phone: "",
      code: "",
      times: 60,
      sysName: "",
      currentResourceItem: null,
      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  computed: {
    // 检查conData中是否已经有学科筛选条件
    hasSubjectInConData() {
      return this.conData.some(item => item.fatherName === "外文学科" || item.fatherName === "学科" || (item.filterField && item.filterField === "secondSubject"));
    },
    hasActiveFilters() {
      return this.sourceList.length > 0 || (this.preSelectedSubject && this.preSelectedSubject.id && !this.hasSubjectInConData) || this.conData.length > 0;
    },
  },
  mounted() {
    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);
    this.imgUrl = baseurl.fileUrl;
    if (localStorage.getItem("roles")) {
      let roleArr = localStorage.getItem("roles").split(",");
      roleArr.forEach(element => {
        if (element == "other") {
          this.roles = false;
        }
      });
    }
    if (localStorage.getItem("sysName")) {
      this.sysName = localStorage.getItem("sysName");
    } else if (localStorage.getItem("systemName")) {
      this.sysName = localStorage.getItem("systemName");
    }
    // 从sessionStorage读取Header的学科检索信息
    if (sessionStorage.getItem("subjectSearchInfo")) {
      try {
        const subjectSearchInfo = JSON.parse(sessionStorage.getItem("subjectSearchInfo"));
        if (subjectSearchInfo.keyword) {
          this.search.keyword = subjectSearchInfo.keyword;
          this.search.searchData = subjectSearchInfo.keyword;
          // 设置为关键词搜索
          this.search.selectVal = "hingeWord";

          // 如果有学科信息，保存学科信息以便左侧菜单预选中
          if (subjectSearchInfo.subjectId && subjectSearchInfo.subjectName) {
            // 保存学科信息以便左侧菜单预选中
            this.preSelectedSubject = {
              id: subjectSearchInfo.subjectId,
              name: subjectSearchInfo.subjectName,
            };
          }
        }
      } catch (e) {
        console.error("解析sessionStorage中的学科检索信息失败:", e);
      }
    } else {
      // 分词检索
      if (sessionStorage.getItem("search-keyword")) {
        let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
        this.search.selectVal = obj.paper;
        this.search.value = parseInt(obj.searchType);
        this.search.keyword = obj.word;
        this.search.searchData = obj.word;
      }
    }
    // 勾选加入馆外非开放获取  传值
    if (JSON.parse(sessionStorage.getItem("joinChecked"))) {
      this.sourceList = [1];
    }
    // if(this.$route.query.keyword){
    //   this.search.keyword= decodeURIComponent(this.$route.query.keyword)
    //   this.searchFields = []
    // }
    this.getOptionsList();

    this.getSubjectData();
    this.getInfo();
  },
  filters: {},

  destroyed() {
    sessionStorage.removeItem("search-keyword");
    sessionStorage.removeItem("heightSearchWord");
    sessionStorage.removeItem("joinChecked");
    // 清理学科检索信息
    sessionStorage.removeItem("subjectSearchInfo");
  },
  methods: {
    //中英文切换
    changeCn(val) {
      this.cnFlag = val;
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    handleHeightSearch() {
      // this.toReset();

      if (this.heightFlag) {
        this.heightFlag = false;
      } else {
        this.heightFlag = true;
      }
    },
    // 重置
    toReset() {
      this.search.selectVal = "";
      this.search.keyword = "";
      this.heightListData = [
        {
          searchField: "title",
          searchWords: "",
          operation: "1",
        },
      ];
      this.publishYearStart = "";
      this.publishYearEnd = "";
      this.subjectWords = "";
      this.subjectFlag = false;
      this.publiserDateFlag = false;
    },
    // 执行高级检索 事件
    handleHeightSearchEvent() {
      let array = [];
      if (!this.publiserDateFlag) {
        this.publishYearStart = "";
        this.publishYearEnd = "";
      } else {
        if (this.publishYearEnd && !this.publishYearStart) {
          this.$message.error("请选择出版起始时间!");
          return;
        }

        if (this.publishYearStart && !this.publishYearEnd) {
          this.$message.error("请选择出版截止时间!");
          return;
        }
      }
      // 学科
      if (this.subjectWords) {
        let searchLabel = this.subjectWords.split("+")[1];
        let searchVal = this.subjectWords.split("+")[0];
        array.push({
          operation: 1,
          searchField: "secondSubject",
          searchLabel: searchLabel,
          searchVal: searchVal,
          searchWords: searchVal,
        });
      }
      array = array.concat(this.heightListData);

      // 过滤掉没有值的
      this.searchArray = array.filter(element => {
        return element.searchWords != "";
      });
      if (this.heightFlag && this.searchArray.length == 0 && !this.publishYearStart && !this.publishYearEnd && !this.search.keyword) {
        this.$message.error("请输入关键词检索!");
        return;
      }
      if (this.search.keyword) {
        this.search.searchData = this.search.keyword.trim();
      }

      this.heightFlag = false;
      this.pageNo = 1;

      this.getList();
      this.getLeftList();
      this.getTopicList();
    },
    // 高级检索 获取学科下拉列表
    getSubjectData() {
      this.$http({
        url: `api/v1/reception/journal/subjectData`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.subjcetList = res.data;
        }
      });
    },
    // 获取下拉选择项
    getOptionsList() {
      this.$http({
        url: "api/v1/reception/journalpaper/dropDownList",
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.search.searchPaperOptions = res.data;
          this.search.selectVal = "";
          res.data.forEach(element => {
            if (element.showName != "全部" && element.showName != "DOI") {
              this.articleList.push({
                label: element.showName,
                value: element.searchFields.toString(),
              });
            }
          });
          this.getList();
          this.getLeftList();
          this.getTopicList();
        }
      });
    },
    //作者展开收起
    showauthor(index) {
      this.list[index].showauthor = false;
      this.list[index].authorArray = this.list[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.list[index].showauthor = true;
      this.list[index].authorArray = [];

      for (let i = 0; i < 5; i++) {
        this.list[index].authorArray.push(this.list[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    // 根据输入的内容获取联想数据
    getKeywordData() {
      let postBody = {
        word: this.search.keyword,
        autoCompletionFieldName: this.search.selectVal,
      };
      this.$http({
        url: `api/v1/reception/journalpaper/suggestion`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.search.searchFlag = false;
          }
          this.search.keywordDataList = res.data;
        }
      });
    },
    // 搜索框输入事件
    // searchKeyword() {
    //   if (this.search.keyword) {
    //     this.search.searchFlag = true;
    //     this.getKeywordData();
    //   } else {
    //     this.search.searchFlag = false;
    //   }
    // },
    // 高级检索添加出版时间
    addPubliserDate() {
      this.publiserDateFlag = true;
    },
    removePublisherDate() {
      this.publiserDateFlag = false;
    },
    // 高级检索添加学科
    addSubject() {
      this.subjectFlag = true;
    },
    removeSubject() {
      this.subjectWords = "";
      this.subjectFlag = false;
    },
    // 高级检索添加检索条件
    addSearch() {
      if (this.heightListData.length < 5) {
        this.heightListData.push({
          searchField: "title",
          searchWords: "",
          operation: "1",
        });
      } else {
        this.$message.warning("不能超过最大限制5条");
      }
    },
    // 高级检索删除检索条件
    remove(index) {
      if (this.heightListData.length == 1) {
        this.heightFlag = false;
        this.heightListData = [
          {
            searchField: "title",
            searchWords: "",
            operation: "1",
          },
        ];
        return;
      }

      this.heightListData.splice(index, 1);
    },
    toSearch() {
      if (this.heightFlag) {
        return;
      }
      if (!this.search.keyword.trim()) {
        // 如没有输入检索词 获取上一次搜索词 进行检索
        if (sessionStorage.getItem("search-keyword")) {
          let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
          this.search.selectVal = obj.paper;
          this.search.value = parseInt(obj.searchType);
          this.search.keyword = obj.word;
          this.search.searchData = obj.word;
        } else {
          if (this.search.selectVal == "") {
            this.$message.error("请输入题名、关键词进行检索!");
            return;
          }
          if (this.search.selectVal == "author" || this.search.selectVal == "author1") {
            this.$message.error("请输入作者进行检索!");
            return;
          }
          if (this.search.selectVal == "journalName") {
            this.$message.error("请输入来源出版物进行检索!");
            return;
          }
          if (this.search.selectVal == "title") {
            this.$message.error("请输入题名进行检索!");
            return;
          }
          if (this.search.selectVal == "digest") {
            this.$message.error("请输入摘要进行检索!");
            return;
          }
          if (this.search.selectVal == "hingeWord") {
            this.$message.error("请输入关键词进行检索!");
            return;
          }
          if (this.search.selectVal == "language") {
            this.$message.error("请输入语种进行检索!");
            return;
          }
          if (this.search.selectVal == "doi") {
            this.$message.error("请输入DOI进行检索!");
            return;
          }
          if (this.search.selectVal == "issn") {
            this.$message.error("请输入ISSN进行检索!");
            return;
          }
          if (this.search.selectVal == "authorOrg") {
            this.$message.error("请输入归属机构进行检索!");
            return;
          }
          if (this.search.selectVal == "fund") {
            this.$message.error("请输入赞助基金进行检索!");
            return;
          }
        }
      }
      //清除高级检索
      // sessionStorage.removeItem("heightSearchWord");
      this.searchArray = [];
      this.search.keyword = this.search.keyword.trim();

      if (this.search.keyword.trim()) {
        sessionStorage.setItem(
          "search-keyword",
          JSON.stringify({
            word: this.search.keyword.trim(),
            paper: this.search.selectVal,
            searchType: this.search.value,
          }),
        );
        this.search.searchData = this.search.keyword.trim();
        // this.upWords = this.search.keyword.trim();
      }
      this.pageNo = 1;
      this.search.searchFlag = false;
      if (this.heightListData.length > 0) {
        this.handleHeightSearchEvent();
      } else {
        this.getList();
        this.getLeftList();
        this.getTopicList();
      }
    },
    // 点击联想关键词事件
    // toSearchKeyword(index) {
    //   if (this.search.selectVal == "language") {
    //     this.search.keyword = this.languageList[index].suggestionWord;
    //   } else {
    //     if (this.search.keywordDataList[index].type == "title") {
    //       let _url = this.$router.resolve({
    //         path: "/articleDetail",
    //         query: { sid: this.search.keywordDataList[index].sid },
    //       });
    //       window.open(_url.href, "_self");
    //     } else {
    //       this.search.keyword = this.search.keywordDataList[index].suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
    //     }
    //   }
    //   this.search.searchData = this.search.keyword;
    //   this.search.searchFlag = false;
    //   this.pageNo = 1;
    //   this.getList();
    //   this.getLeftList();
    //   this.getTopicList();
    // },
    placeholderName() {
      if (this.search.selectVal == "") {
        return "请输入题名、关键词进行检索";
      }
      if (this.search.selectVal == "author" || this.search.selectVal == "author1") {
        return "请输入作者";
      }
      if (this.search.selectVal == "journalName") {
        return "请输入来源出版物";
      }
      if (this.search.selectVal == "title") {
        return "请输入题名";
      }
      if (this.search.selectVal == "hingeWord") {
        return "请输入关键词";
      }
      if (this.search.selectVal == "language") {
        return "请输入语种";
      }
      if (this.search.selectVal == "doi") {
        return "请输入DOI";
      }
      if (this.search.selectVal == "issn") {
        return "请输入ISSN";
      }
      if (this.search.selectVal == "authorOrg") {
        return "请输入归属机构";
      }
      if (this.search.selectVal == "fund") {
        return "请输入赞助基金";
      }
    },
    // 获取焦点时触发
    getInputFocus() {
      // 语种特殊处理
      if (this.search.selectVal == "language") {
        this.search.searchFlag = true;
        this.getLanquageList();
      } else {
        this.search.searchFlag = false;
      }
    },
    closeLan() {
      this.search.searchFlag = false;
    },
    // 检索方式切换
    handleChangeSelect() {
      // this.search.keyword = "";
    },
    // 获取语种列表
    getLanquageList() {
      let postBody = {
        word: "",
        autoCompletionFieldName: "language",
      };
      this.$http({
        url: `api/v1/reception/journalpaper/suggestion?autoCompletionFieldName=language&word=`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.search.searchFlag = true;
          this.languageList = res.data;
        }
      });
    },
    // 关键词检索
    searchWords(item) {
      let val = item.split("<span style='color:red'>").join("").split("</span>").join("");
      this.search.keyword = val;
      this.search.searchData = val;
      this.search.selectVal = "";
      this.pageNo = 1;
      this.getList();
      this.getLeftList();
      this.getTopicList();
    },
    getLeftList() {
      let array = [];
      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });

      // 处理从Header传递过来的学科信息，作为筛选条件
      // 只有在左侧菜单还没有选中任何学科时，才添加预选中的学科
      if (this.preSelectedSubject && this.preSelectedSubject.id && this.preSelectedSubject.name) {
        // 检查是否已经存在相同的学科筛选条件（从左侧菜单选择的或已经添加的），避免重复添加
        const hasSubjectFilter = array.some(item => item.filterField === "secondSubject" && item.filterValue.includes(this.preSelectedSubject.name));
        // 检查左侧菜单是否已经有学科筛选条件
        const hasLeftMenuSubjectFilter = this.filterData.some(item => item.filterField === "secondSubject");
        if (!hasSubjectFilter && !hasLeftMenuSubjectFilter) {
          array.push({
            filterField: "secondSubject",
            filterValue: [this.preSelectedSubject.name],
            type: null,
          });
        }
      }

      // 写死 的 资源来源过滤
      if (window.config && window.config.type == "oa") {
        array.push({
          filterField: "oaType",
          filterValue: ["20"],
          type: "metric",
        });
      }
      // 检索时修改 下拉框值
      let searchSelectVal = null;
      this.search.searchPaperOptions.forEach(element => {
        if (element.autoCompletionFieldName == this.search.selectVal) {
          searchSelectVal = element.searchFields;
        }
      });
      // 如果输入doi 把大写字母转成小写传给后台
      if (this.search.keyword.trim().substring(0, 3) == "10.") {
        this.newWord = this.convertToLowercase(this.search.keyword.trim());
      } else {
        this.newWord = this.search.keyword.trim();
      }
      let postBody = {
        searchWord: this.newWord,
        searchFields: this.search.keyword.trim().substring(0, 3) == "10." && !this.searchFields ? ["doi"] : searchSelectVal, //如果是全部  输入的又是doi格式  强制成['doi']
        // searchFields: this.searchFields,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        paramList: this.searchArray,
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
        publishYearStart: this.publishYearStart,
        publishYearEnd: this.publishYearEnd,
      };
      let _url = "api/v1/reception/journalpaper/listAgg2";
      this.leftLoading = true;
      this.$http({
        url: _url,
        method: "POST",
        data: postBody,
      }).then(res => {
        this.leftLoading = false;

        res.data.left.forEach(element => {
          //默认展开 显示全部  否则默认显示5条记录
          if (element.name == "核心期刊" || element.name == "学科分类") {
            element.drop = true;
            element.dropNum = element.items.length;
          } else {
            element.dropNum = 5;
          }
        });
        this.leftData = res.data.left;

        // 如果有预选中的学科信息，在左侧数据加载完成后触发预选中
        if (this.preSelectedSubject) {
          this.$nextTick(() => {
            // 通过ref直接调用leftMenu的方法
            if (this.$refs && this.$refs.leftMenuRef) {
              this.$refs.leftMenuRef.selectSubjectByInfo(this.preSelectedSubject);
            }
          });
        }
      });
    },
    convertToLowercase(str) {
      return str.toUpperCase().toLowerCase();
    },
    getList() {
      let array = [];
      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });

      // 处理从Header传递过来的学科信息，作为筛选条件
      // 只有在左侧菜单还没有选中任何学科时，才添加预选中的学科
      if (this.preSelectedSubject && this.preSelectedSubject.id && this.preSelectedSubject.name) {
        // 检查是否已经存在相同的学科筛选条件（从左侧菜单选择的或已经添加的），避免重复添加
        const hasSubjectFilter = array.some(item => item.filterField === "secondSubject" && item.filterValue.includes(this.preSelectedSubject.name));
        // 检查左侧菜单是否已经有学科筛选条件
        const hasLeftMenuSubjectFilter = this.filterData.some(item => item.filterField === "secondSubject");
        if (!hasSubjectFilter && !hasLeftMenuSubjectFilter) {
          array.push({
            filterField: "secondSubject",
            filterValue: [this.preSelectedSubject.name],
            type: null,
          });
        }
      }

      // 写死 的 资源来源过滤
      if (window.config && window.config.type == "oa") {
        array.push({
          filterField: "oaType",
          filterValue: ["20"],
          type: "metric",
        });
      }
      // 检索时修改 下拉框值
      let searchSelectVal = null;
      this.search.searchPaperOptions.forEach(element => {
        if (element.autoCompletionFieldName == this.search.selectVal) {
          searchSelectVal = element.searchFields;
        }
      });
      // 如果输入doi 把大写字母转成小写传给后台
      if (this.search.keyword.trim().substring(0, 3) == "10.") {
        this.newWord = this.convertToLowercase(this.search.keyword.trim());
      } else {
        this.newWord = this.search.keyword.trim();
      }
      let postBody = {
        searchWord: this.newWord,
        searchFields: this.search.keyword.trim().substring(0, 3) == "10." && !this.searchFields ? ["doi"] : searchSelectVal, //如果是全部  输入的又是doi格式  强制成['doi']
        // searchFields: this.searchFields,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        paramList: this.searchArray,
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
        publishYearStart: this.publishYearStart,
        publishYearEnd: this.publishYearEnd,
      };
      let _url = "api/v1/reception/journalpaper/list2";
      this.loading = true;
      this.$http({
        url: _url,
        method: "POST",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
        this.list = res.data.recordList;

        this.list.forEach((element, index) => {
          try {
            this.list[index].title = decodeURIComponent(element.title);
          } catch (e) {
            // 解码失败时保留原始内容，并添加错误处理
            this.list[index].title = element.title;
            // console.error('URI解码失败:', e);
          }
          if (element.hingeWord) {
            this.list[index].hingeWordArray = element.hingeWord.split(";");
          }
          if (element.author) {
            this.$set(this.list[index], "authorAllArray", element.authorList);
            this.$set(this.list[index], "authorArray", element.authorAllArray.slice(0, 5));
          }
          if (element.digest) {
            this.list[index].digestAll = element.digest.split("<span style='color:red'>").join("").split("</span>").join("");
          }
          element.open = false; //摘要展开收起标识
          element.showauthor = true; //作者展开收起标识
          element.btnLoading = false;
        });
        if (this.search.keyword && this.list.length == 0) {
          if (this.search.keyword.substring(0, 3) != "10.") {
            this.$message.warning("未检索到文章，试试DOI检索");
          }
        }
      });
    },
    // 获取话题列表
    getTopicList() {
      this.topicLoading = true;
      let word = "";
      if (this.searchArray.length > 0) {
        word = this.searchArray[0].searchWords;
      }
      // 如果输入doi 把大写字母转成小写传给后台
      if (this.search.keyword.trim().substring(0, 3) == "10.") {
        this.newWord = this.convertToLowercase(this.newWord);
      } else {
        this.newWord = this.newWord;
      }
      if (!word && !this.newWord) {
        this.topicLoading = false;
        this.topicList = [];
        return;
      }
      let postBody = {
        searchWord: word ? word : this.newWord,
      };
      this.$http({
        url: "api/v1/reception/journalpaper/topic/sub/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.topicLoading = false;
        this.topicList = res.data;
      });
    },
    // 摘要展开
    showDigest(index) {
      this.list[index].open = true;
      this.$forceUpdate();
    },
    closeDigest(index) {
      this.list[index].open = false;
      this.$forceUpdate();
    },
    // 引用
    showReference(item) {
      this.dialogIndex = 1;
      this.exportSid = item.sid;
      this.$http({
        url: `api/v1/reception/journalpaper/getReference?sid=${item.sid}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.BIBObj = res.data.bib;
          this.CITEArray = [];
          if (res.data.mla) {
            this.CITEArray.push({
              name: "MLA",
              value: res.data.mla,
            });
          }
          if (res.data.apa) {
            this.CITEArray.push({
              name: "APA",
              value: res.data.apa,
            });
          }
          if (res.data.chicago) {
            this.CITEArray.push({
              name: "Chicago",
              value: res.data.chicago,
            });
          }
          if (res.data.gb) {
            this.CITEArray.push({
              name: "GB",
              value: res.data.gb,
            });
          }
          this.referenceDialog = true;
        }
      });
    },
    // 复制
    copyContent(val) {
      this.$copyText(val).then(
        () => {
          this.$message.success("复制成功");
          // 复制成功的操作
        },
        () => {
          this.$message.error("复制失败");
          // 复制失败的操作
        },
      );
    },
    // 导出
    handleExport(type) {
      let url = "";
      if (type == "bib") {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportBibTexReference?sid=" + this.exportSid;
      } else {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportEndNoteReference?sid=" + this.exportSid;
      }
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: localStorage.getItem("jyx_token"),
        },
        url,
      };

      Axios(options).then(res => {
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); //创建下载的链接
        let a = document.createElement("a");
        a.href = objectUrl;

        // 获取文件名
        let fileName = type == "bib" ? "publication.bib" : "publication.enw";
        fileName = decodeURI(fileName);
        a.download = fileName; //设置文件名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl); //释放bolb对象
      });
    },
    changeDialogTab(index) {
      this.dialogIndex = index;
    },

    getString(data) {
      if (data) {
        return data.toString().split(",").join(" ; ");
      }
    },
    isLastElement(index) {
      return index === this.list[index].authorArray.length - 1;
    },
    handleCurrentChange(val) {
      if (this.searchArray.length == 0 && !this.publishYearStart && !this.publishYearEnd && !this.subjectWords) {
        //如果高级检索有搜索条件 搜索框不执行自动获取上一次搜索词
        if (!this.search.keyword.trim()) {
          // 如没有输入检索词 获取上一次搜索词 进行检索
          if (sessionStorage.getItem("search-keyword")) {
            let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
            this.search.selectVal = obj.paper;
            this.search.value = parseInt(obj.searchType);
            this.search.keyword = obj.word;
            this.search.searchData = obj.word;
          }
        }
      }

      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    childByValue(val) {
      if (!this.search.keyword.trim()) {
        // 如没有输入检索词 获取上一次搜索词 进行检索
        if (sessionStorage.getItem("search-keyword")) {
          let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
          this.search.selectVal = obj.paper;
          this.search.value = parseInt(obj.searchType);
          this.search.keyword = obj.word;
          this.search.searchData = obj.word;
        }
      }
      this.pageNo = 1;
      this.conData = val.filterArray;
      this.filterData = val.newNarr;
      this.getList();
      if (this.shouldRefreshLeftAfterFilterDelete) {
        this.shouldRefreshLeftAfterFilterDelete = false;
        this.getLeftList();
      }
      this.getTopicList();
    },
    // 资源来源
    sourceByValue(val) {
      if (!this.search.keyword.trim()) {
        // 如没有输入检索词 获取上一次搜索词 进行检索
        if (sessionStorage.getItem("search-keyword")) {
          let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
          this.search.selectVal = obj.paper;
          this.search.value = parseInt(obj.searchType);
          this.search.keyword = obj.word;
          this.search.searchData = obj.word;
        }
      }

      this.loading = true;
      this.pageNo = 1;
      this.sourceList = val;
      this.delSource = 0;
      this.getList();
      if (this.shouldRefreshLeftAfterFilterDelete) {
        this.shouldRefreshLeftAfterFilterDelete = false;
        this.getLeftList();
      }
      this.getTopicList();
    },
    toDetail(index) {
      let item = this.list[index];
      // let doi = val.split("<span style='color:red'>").join("").split("</span>").join("");
      if (item.sid) {
        let _url = this.$router.resolve({
          path: "/articleDetail",
          query: { sid: item.sid },
        });
        window.open(_url.href, "_blank");
        this.list[index].visited = true;
      } else {
        if (item.detailUrl) {
          window.open(item.detailUrl);
        } else {
          let url = "https://doi.org/" + item.doi;
          window.open(url, "_blank");
        }
      }
    },
    gethttp(val) {
      if (val.indexOf("http") == 0) {
        return true;
      }
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    // 收藏
    isCollect(item) {
      let postBody = {
        outSid: item.sid,
        type: 2,
      };
      this.$http({
        url: `api/v1/usershare/collect`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data == 1) {
            window.location.href = `${baseurl.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
          } else {
            if (!item.share) {
              this.$message.success("收藏成功");
            }
            this.getList();
          }
        }
      });
    },
    //跳转外部扩展链接
    literatureUrl(item) {
      if (item.indexOf("apply/paper/resource") > 0) {
        this.getResourceDetail(item);
      } else {
        this.Resourcelist = false;
        window.open(item);
      }
    },
    //获取全文
    getResource(item, index) {
      // if (item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.$message.error("馆外无法获取资源");
      //   this.achieveloading = false;
      //   return;
      // }
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”
      // 10, “未登录”
      if (this.list[index].btnLoading) {
        return;
      }
      this.list[index].btnLoading = true;
      this.$forceUpdate();

      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.data) {
          this.list[index].btnLoading = false;
          this.$forceUpdate();
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];

          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
            // if (res.data.detailUrl) {
            //   window.open(res.data.detailUrl);
            // } else {
            //   this.$router.push({ path: "fourfour" });
            // }
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            // if (res.data.gainResourceBo.provideType === 4) {
            //   this.Resourcelist = false;
            //   this.$message.error("馆外无法获取资源");
            //   this.achieveloading = false;
            //   return;
            // }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            // window.open(`/lg?word=true&isback=true`, "_self");
            // window.open(window.location.origin + '/lg?word=true', '_blank');
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
    },
    //复制引文
    copylist(id) {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + id,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    // 馆藏资源跳转
    libdetailUrl(item, bookItem) {
      this.Resourcelist = false;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = item.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + item.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    // 文献传递
    getDeliverSave(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + item.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },

    closeDialog(val) {
      this.stateDialogVisible = val;
    },
    toHome() {
      this.$router.push({ path: "/articleSearch" });
    },
    // 期刊信息跳转
    toHomeDetail(item) {
      let _url = this.$router.resolve({
        path: "homeDetail",
        query: { sid: item.journalSid },
      });
      window.open(_url.href, "_self");
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
      return;

      // this.$http({
      //   url: `api/v1/reception/author/checkAuthorJumpDetail?authorSid=${authorSid}`,
      //   method: "get",
      // }).then(res => {
      //   setTimeout(() => {
      //     if (res.code == 200) {
      //       if (res.data) {
      //         let _url = this.$router.resolve({
      //           path: "/authorDetail",
      //           query: { authorSid: authorSid },
      //         });
      //         window.open(_url.href, "_blank");
      //       } else {
      //         this.$message.error("该作者暂无收录");
      //       }
      //     }
      //   }, 500);
      // });
    },
    // 跳转高级检索
    // toHightSearch() {
    //   this.$router.push({ path: "/search", query: { type: "article" } });
    // },

    // 排序
    handleChangeSort(index) {
      if (!this.search.keyword.trim()) {
        // 如没有输入检索词 获取上一次搜索词 进行检索
        if (sessionStorage.getItem("search-keyword")) {
          let obj = JSON.parse(sessionStorage.getItem("search-keyword"));
          this.search.selectVal = obj.paper;
          this.search.value = parseInt(obj.searchType);
          this.search.keyword = obj.word;
          this.search.searchData = obj.word;
        }
      }
      this.sortIndex = index;
      this.sortVal = this.sortList[this.sortIndex].value;
      this.pageNo = 1;
      this.getList();
    },
    handleDelSource(item) {
      this.shouldRefreshLeftAfterFilterDelete = true;
      this.delSource = item;
    },
    // 处理删除学科筛选条件
    handleDelSubject() {
      this.preSelectedSubject = null;
      // 清理sessionStorage中的学科检索信息
      sessionStorage.removeItem("subjectSearchInfo");
      // 重新加载数据
      this.getList();
      this.getLeftList();
      this.getTopicList();
    },
    // 处理删除筛选条件
    handleDelName(item) {
      this.shouldRefreshLeftAfterFilterDelete = true;
      if (this.$refs && this.$refs.leftMenuRef && this.$refs.leftMenuRef.removeFilterItem) {
        this.$refs.leftMenuRef.removeFilterItem(item);
      } else {
        this.delName = item;
      }
      // 如果删除的是学科相关的筛选条件，清理sessionStorage
      if (item && item.onlyFlag && item.onlyFlag.includes("subject_")) {
        sessionStorage.removeItem("subjectSearchInfo");
        // 清理预选中学科信息
        this.preSelectedSubject = null;
      }

      // 重置delName避免重复触发
      this.$nextTick(() => {
        this.delName = null;
      });
    },
    // 清理预选中学科信息的方法
    clearPreSelectedSubject() {
      sessionStorage.removeItem("subjectSearchInfo");
      this.preSelectedSubject = null;
    },
    bodyCloseMenus(e) {
      // 获取全文里的弹框
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
      // 语种下拉弹框
      this.search.searchFlag = false;
    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseMenus);
    },
    //oa状态
    getColor(item) {
      return oaColor(item);
    },
    getoatext(item) {
      return oaText(item);
    },
    toTopicDetail(item) {
      sessionStorage.setItem("topicWord", JSON.stringify(item.description));
      let _url = this.$router.resolve({
        path: "/topicSearch",
      });
      window.open(_url.href, "_self");
    },
    //添加到文件夹
    handleChoiseFolder(index) {
      if (this.folderIndex === index || this.folderList[index].exist) {
        this.folderIndex = null;
        this.folderList[index].exist = false;
      } else {
        this.folderIndex = index;
      }
      this.checkFolder = true;
      this.foldershare = false;
    },
    cannalFolder() {
      this.folderList.shift();
    },
    // 新增文件夹
    submitAddFolder() {
      if (!this.folderList[0].name.trim()) {
        this.$message.error("请输入文件夹名称");
        return;
      }
      const newFolderName = this.folderList[0].name.trim(); // 保存新建文件夹名称
      let postBody = {
        name: newFolderName,
      };
      this.$http({
        url: "/api/v1/ai-service/folder/save",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("新增成功");
          let folderSid = this.folderSid ? this.folderSid : "";
          let foldershare = this.foldershare ? this.foldershare : "";
          // 现在可以使用then了
          this.getFolderList(folderSid, foldershare).then(() => {
            // 查找并选中刚刚新建的文件夹
            for (let i = 0; i < this.folderList.length; i++) {
              if (this.folderList[i].name === newFolderName) {
                this.folderIndex = i;
                this.checkFolder = true;
                break;
              }
            }
          });
          EventBus.$emit("reloadFolder", true);
        }
      });
    },
    // 新建文件夹
    newAddFolder() {
      if (this.folderList.length >= 20) {
        this.$message.error("最多可以创建20个文件夹");
        return;
      }
      if (this.folderList.length > 0) {
        if (!this.folderList[0].name.trim()) {
          return;
        }
      }

      const container = this.$refs.myScroll;
      container.scrollTo({
        top: 0, // 滚动到的位置
        behavior: "smooth", // 平滑滚动效果
      });

      this.folderList.unshift({ name: "", addFlag: true });
    },
    // 单独添加和多选添加共用 将文献添加到文件夹
    submitFolder() {
      if (!this.checkFolder && this.foldershare) {
        this.$message.success(`收藏成功`);
        this.addFodlerDialog = false;
        return;
      }
      // this.folderSid 有值 代表单独添加   没值就是多选添加
      let folderSid = this.folderIndex !== null && this.folderIndex !== undefined ? this.folderList[this.folderIndex].sid : "";
      let sidArray = this.folderSid;
      let postBody = {
        folderSid: folderSid,
        paperSid: sidArray,
      };
      this.$http({
        url: `/api/v1/ai-service/user-literature/collectAddPaper`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (this.folderIndex !== null && this.folderIndex !== undefined) {
          this.$message.success(`成功收藏到"${this.folderList[this.folderIndex].name}"文件夹下`);
        } else {
          this.$message.success(`收藏成功`);
        }

        this.getList();
        this.addFodlerDialog = false;
      });
    },
    // 添加文献到文件夹
    getFolderList(sid, share) {
      let formData = "";
      // 单个添加文件夹
      if (sid) {
        // document.body.click();
        this.folderSid = sid;
        this.foldershare = share;
        formData = new FormData();
        formData.append("paperSid", sid);
      } else {
        this.folderSid = "";
      }
      // 返回Promise对象
      return new Promise(resolve => {
        this.$http({
          url: `/api/v1/ai-service/folder/paperOptionList`,
          method: "POST",
          data: formData,
        }).then(res => {
          this.folderList = res.data;
          this.folderIndex = null;
          this.checkFolder = false;
          this.addFodlerDialog = true;
          resolve(); // 成功时resolve
        });
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    clearAllFilters() {
      this.sourceList = [];
      this.preSelectedSubject = null;
      this.conData = [];
      this.filterData = [];
      this.pageNo = 1;
      this.delAll = new Date().getTime();
      // 清理学科检索信息
      sessionStorage.removeItem("subjectSearchInfo");
      this.getList();
      this.getLeftList();
      this.getTopicList();
      this.$message.success("已清空全部筛选条件");
    },
    // 上一页
    handlePrevPage() {
      if (this.pageNo > 1) {
        this.pageNo--;
        this.getList();
      }
    },
    // 下一页
    handleNextPage() {
      if (this.pageNo < Math.ceil(this.total / this.pageSize)) {
        this.pageNo++;
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .article-search {
    width: 100%;
    padding-top: 40px;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    .search-wapper {
      width: calc(100% - 40px);
      max-width: 1380px;
      min-width: 0;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }
    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      span {
        color: #cccccc;
      }
    }
    .search {
      align-items: center;
      justify-content: center;
      .search_div {
        align-items: center;
        margin-top: 30px;
        margin-bottom: 15px;
        position: relative;
        a {
          font-size: 18px;
          text-decoration: underline;
          &:hover {
            text-decoration: underline;
          }
        }
        .title-select {
          width: 130px;
          margin-right: 10px;
          ::v-deep .el-input__inner {
            height: 48px;
            border: 1px solid #ccc;
            border-radius: 0;
          }
        }

        .search-height {
          position: absolute;
          z-index: 99;
          top: 50px;
          left: 0px;
          width: min(840px, calc(100vw - 64px));
          max-height: calc(100vh - 100px);
          overflow-y: auto;
          min-height: 250px;
          background: #ffffff;
          border: 1px solid #cccccc;
          padding: 20px;
          ::v-deep .el-select,
          ::v-deep .el-input {
            margin-right: 10px;
            .el-input__inner {
              border-radius: 0;
              height: 40px;
              border: 1px solid #ccc;
            }
            // border: 1px solid #333;
          }
          .opera {
            width: 90px;
          }
          .field {
            width: 220px;
          }
          .flex {
            align-items: center;
            margin-bottom: 10px;
            &:last-of-type {
              margin: 0;
            }
          }
          i {
            margin-left: 10px;
            cursor: pointer;
            background: #2d8cf0;
            color: #fff;
            padding: 3px;
            color: #fff;
          }
          .time-height {
            margin-top: 10px;
            ::v-deep .el-input__inner {
              width: 360px;
            }
            .el-date-editor {
              width: 360px;
            }
            > span {
              margin-right: 10px;
            }
          }
          .subject-height {
            margin-top: 10px;
            display: flex;
            align-items: center;
            .el-select {
              width: 100%;
            }
          }
          .btns-height {
            display: flex;
            align-items: center;
            margin-top: 20px;
            span {
              color: #2d8cf0;
              text-decoration: underline;
              margin-right: 20px;
              cursor: pointer;
            }
            .btns {
              margin-left: auto;
              ::v-deep .el-button {
                border-radius: 0;
                width: 80px;
                height: 40px;
              }
              ::v-deep .el-button--info {
                background: #f7f7f7 !important;
                color: #333;
                border: #f7f7f7;
              }
            }
          }
        }
      }
      .searchLeft {
        border: 1px solid #cccccc;
        width: min(700px, calc(100vw - 420px));
        min-width: 0;
        height: 48px;
        background: #fff;
        position: relative;
        ::v-deep .el-input__inner {
          border: none;
          height: 48px;
          background: none;
          border-radius: 0;
        }
        .el-select {
          position: relative;
          width: 110px;
          // &::after {
          //   content: "";
          //   position: absolute;
          //   right: -2px;
          //   top: 50%;
          //   margin-top: -12px;
          //   width: 1px;
          //   height: 24px;
          //   background: #cccccc;
          //   background: #006eb2;
          // }
        }
        .inputDiv {
          align-items: center;
          flex: 1;
          background: #fff;
          ::v-deep .el-input {
            flex: 1;
          }
          .default {
            cursor: not-allowed !important;
          }
          .search-btn {
            cursor: pointer;
            margin-right: 4px;
            width: 66px;
            height: 40px;
            background: #2d8cf0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .search-input {
          padding-right: 10px;
          padding-top: 9px;
          position: absolute;
          z-index: 99999;
          top: 48px;
          left: -1px;
          width: 100%;
          height: 260px;
          background: #ffffff;
          border: 1px solid #cccccc;
          color: #666;
          ::-webkit-scrollbar {
            display: block;
            width: 3px; /* 定制滚动条的宽度 */
          }
          /* 定制滚动条滑块样式 */
          ::-webkit-scrollbar-thumb {
            background-color: #2d8cf0;
          }
          ul {
            height: 248px;
            overflow: auto;
          }
          li {
            height: 30px;
            line-height: 30px;
            padding-left: 15px;
            cursor: pointer;
            &:hover {
              background: #f0f7f7;
            }
          }
        }
      }
      a {
        color: #2d8cf0;
        margin-left: 10px;
      }
    }
    .search_nav {
      color: #999999;
      font-size: 14px;
      position: absolute;
      left: 0;
      bottom: 10px;
    }
    .item {
      padding-left: 15px;
      li {
        display: flex;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
        color: #666666;
        font-size: 14px;
        img {
          margin-right: 5px;
        }
      }
    }
  }
  .w1580 {
    min-height: calc(100vh - 444px);
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    width: calc(100% - 40px);
    max-width: 1580px;
    min-width: 0;
    align-items: flex-start;
    .right-list {
      flex: 1;
      min-width: 0;
      .right-top {
        background: #fff;
      }
      .filter {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #eeeeee;
        line-height: 30px;
        .searchword {
          margin-right: 20px;
          .red {
            color: #ff0000;
          }

          label {
            color: #2d8cf0;
          }
        }

        .flex {
          display: inline-block;
          border: 1px solid #cccccc;
          color: #2d8cf0;
          font-size: 14px;
          padding: 2px 5px;
          margin-right: 10px;
          i {
            margin-left: 5px;
            font-size: 12px;
            color: #999999;
            cursor: pointer;
          }
        }
        .clear-all {
          cursor: pointer;
          margin-right: 10px;
          color: #e40000;
        }
      }
      .total {
        padding: 15px;
        color: #666666;
        display: flex;
        align-items: center;
        label {
          margin: 0 3px;
        }
        p {
          margin-left: auto;
          ::v-deep .el-input__inner {
            width: 140px;
            border: none;
            background: #f7f7f7;
          }
        }
      }
      .right-item {
        background: #fff;
        margin-top: 10px;
        .pagination-controls {
          display: flex;
          align-items: center;
          margin-left: auto;
        }

        .page-btn {
          width: 36px;
          height: 36px;
          border: 1px solid #dcdfe6;
          background-color: #fff;
          color: #606266;
          cursor: pointer;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          margin: 0 4px;
          transition: all 0.3s;
        }

        .page-btn:hover:not(:disabled) {
          color: #2d8cf0;
          border-color: #2d8cf0;
        }

        .page-btn:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .page-info {
          margin: 0 8px;
          color: #606266;
          font-size: 14px;
        }

        /* 修复排序选项的样式，确保它们不会被分页控件挤压 */
        .sort-item > p {
          margin-right: 30px;
          font-size: 16px;
          font-weight: bold;
          display: inline-block;
          cursor: pointer;
          position: relative;
          &:hover {
            color: #2d8cf0;
            &::before {
              content: "";
              position: absolute;
              bottom: -21px;
              left: 50%;
              margin-left: -25px;
              height: 2px;
              width: 50px;
              z-index: 88;
              background: #2d8cf0;
            }
          }
        }
        .sort-item {
          display: flex;
          border-bottom: 1px solid #eee;
          padding: 20px 20px 13px 20px;
          align-items: center;
          justify-content: space-between;
          position: relative;
          p {
            margin-right: 30px;
            font-size: 16px;
            font-weight: bold;
            display: inline-block;
            cursor: pointer;
            position: relative;
            &:hover {
              color: #2d8cf0;
              &::before {
                content: "";
                position: absolute;
                bottom: -21px;
                left: 50%;
                margin-left: -25px;
                height: 2px;
                width: 50px;
                z-index: 88;
                background: #2d8cf0;
              }
            }
          }
          .checked {
            color: #2d8cf0;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              bottom: -21px;
              left: 50%;
              margin-left: -25px;
              height: 2px;
              width: 50px;
              z-index: 88;
              background: #2d8cf0;
            }
          }
        }
        ul {
          padding: 0 20px;

          li {
            padding: 20px 0;
            border-bottom: 1px dashed #eeeeee;
            .index {
              width: 50px;
              line-height: 30px;
            }
            .right-info {
              color: #666666;
              flex: 1;
              min-width: 0;
              p {
                &:nth-of-type(1) {
                  img {
                    margin-left: 5px;
                    vertical-align: text-bottom;
                  }
                }
              }
              .green {
                color: #2d8cf0;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .mr5 {
                margin-right: 5px;
              }
              .active {
                display: inline-block;
                white-space: nowrap;
                width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: bottom;
              }
              .undline {
                color: #2d8cf0;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .btn {
                display: flex;
                align-items: center;
              }
              > p {
                line-height: 30px;
                position: relative;
                .fenhao {
                  cursor: pointer;
                  &:hover {
                    text-decoration: underline;
                  }
                  label {
                    cursor: pointer;
                    &:last-of-type {
                      margin: 0 5px;
                    }
                  }
                }
                .read_tag {
                  font-weight: normal;
                  text-align: center;
                  color: #fff;
                  vertical-align: middle;
                  background: #fa8c16;
                  width: 32px;
                  height: 14px;
                  margin-right: 5px;
                  padding: 0;
                  font-size: 10px;
                  line-height: 14px;
                  display: inline-block;
                  margin-bottom: 2px;
                }
                &:nth-of-type(1) {
                  color: #333;
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  cursor: pointer;
                  label {
                    font-size: 14px;
                    padding-left: 5px;
                    width: 60px;
                    line-height: 22px;
                    text-align: center;
                    color: white;
                    font-weight: initial;
                    padding: 2px 5px;
                    margin-left: 5px;
                  }
                }
                .digestLabel {
                  cursor: pointer;
                  margin-left: 10px;
                  &:hover {
                    color: #2d8cf0;
                  }
                }
                .span-content {
                  position: relative;
                  .author-content {
                    top: 30px;
                    left: 0px;
                  }
                }
                .green_span {
                  cursor: pointer;
                  &:hover {
                    .span_a {
                      text-decoration: underline;
                    }
                    transition: all 1s;
                    .author-content {
                      display: inline-block;
                    }
                  }
                  .span_a {
                    color: #2d8cf0;
                  }
                }
              }
              .author-content {
                position: absolute;
                background: #fff;
                box-shadow: 0 0 5px #d3d3d3;
                display: none;
                padding: 10px;
                z-index: 9999;
                top: -30px;
                right: -210px;
                min-width: 300px;
                .mb10 {
                  font-size: 16px;
                  margin-bottom: 10px !important;
                }
                .hui {
                  margin-top: 5px !important;
                  white-space: pre-wrap;
                }
                p {
                  font-size: 14px;
                  margin: 0 !important;
                  line-height: 20px;
                  span {
                    position: relative;
                    &:first-of-type {
                      margin-right: 14px;
                      &::before {
                        content: "";
                        position: absolute;
                        width: 1px;
                        height: 14px;
                        background: #ccc;
                        right: -7px;
                        top: 50%;
                        margin-top: -7px;
                      }
                    }
                    label {
                      color: #2d8cf0;
                    }
                  }
                }
              }
              .btn-p {
                align-items: end;
                margin-top: 25px;
                .num-tips {
                  span {
                    // color: #2d8cf0;
                    margin-left: 5px;
                  }
                }
                .share {
                  font-style: normal;
                  color: #2d8cf0;
                  margin-left: 5px;
                }
              }
              .btn-right {
                margin-left: auto;
                display: flex;
                align-items: center;
                .rotating-image {
                  animation: rotate 1s linear infinite;
                }
                @keyframes rotate {
                  from {
                    transform: rotate(0deg);
                  }
                  to {
                    transform: rotate(360deg);
                  }
                }
                img {
                  margin-top: 2px;
                  margin-right: 5px;
                }
                .checked {
                  color: #2d8cf0;
                }
                .collect-action {
                  color: #2d8cf0;
                }
                .noCourse {
                  cursor: default !important;
                }
                .flex {
                  align-items: center;
                  margin-left: 30px;
                  cursor: pointer;
                  position: relative;
                  &:hover {
                    color: #2d8cf0;
                    text-decoration: underline;
                    .hover-img {
                      display: inline-block;
                    }
                    .img {
                      display: none;
                    }
                  }

                  .hover-img {
                    display: none;
                  }
                  &.article-action-active,
                  .article-action-active {
                    color: #2d8cf0;
                    .hover-img {
                      display: inline-block;
                    }
                    .img {
                      display: none;
                    }
                  }
                }
              }
            }
            &:hover {
              .right-info {
                > p {
                  &:nth-of-type(1) {
                    background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    label {
                      -webkit-text-fill-color: initial;
                    }
                    .read_tag {
                      -webkit-text-fill-color: initial;
                    }
                  }
                }
              }
            }

            .achieve {
              background: #ffffff;
              border-radius: 2px;
              box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
              position: absolute;
              top: 35px;
              right: 0;
              z-index: 99999;
              cursor: text;

              &::after {
                content: "";
                position: absolute;
                top: -6px;
                right: 10px;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 10px solid #fff; /* 三角形的颜色 */
              }
              .achieve-li {
                min-width: 270px;
                max-width: 700px;
                overflow-y: auto;
                max-height: 200px;
                padding: 15px 20px;
              }

              li {
                font-size: 16px;
                line-height: 28px;
                padding: 0px;
                border-bottom: 0px;
                a {
                  text-decoration: underline;
                  color: #2d8cf0;
                  cursor: pointer;
                }
                span {
                  font-size: 14px;
                  color: #b3b3b3;
                  margin-left: 5px;
                }
                font {
                  color: #b3b3b3;
                  font-size: 12px;
                  display: block;
                  line-height: 20px;
                  i {
                    margin-right: 5px;
                    color: #e6a23c;
                  }
                }
                .el-icon-warning {
                  color: #e6a23c;
                  padding: 0px 10px;
                  width: 30px;
                }
              }
            }
            ::-webkit-scrollbar {
              display: block;
              width: 3px; /* 定制滚动条的宽度 */
            }
            /* 定制滚动条滑块样式 */
            ::-webkit-scrollbar-thumb {
              background-color: #2d8cf0;
            }
            ::-webkit-scrollbar-track {
              background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
            }
          }
        }
      }
    }
    .topicList {
      width: 250px;
      background: #fff;
      margin-left: 20px;
      align-items: flex-start;
      h3 {
        background-image: linear-gradient(to right, #edfafa, #fff);
        margin-top: 5px;
        font-weight: normal;
        font-size: 16px;
        padding: 15px 20px;
        width: 180px;
      }
      ul {
        padding: 20px;
        min-height: 600px;

        li {
          margin-bottom: 20px;
          &:last-of-type {
            margin: 0;
          }
          &:hover {
            p {
              &:nth-of-type(1) {
                background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }
          p {
            line-height: 22px;
            cursor: pointer;
            &:nth-of-type(1) {
              font-weight: bold;
              margin-bottom: 5px;
            }
            &:nth-of-type(2) {
              color: #666666;
            }
          }
        }
      }
    }
  }
  .digestLabel {
    cursor: pointer;
    margin-left: 10px;
    &:hover {
      color: #2d8cf0;
    }
  }
  // 更改输入框清除图标
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      border-color: none;
      .el-input__clear {
        position: relative;
        // 默认清空按钮隐藏
        &::before {
          display: none;
        }
      }
      .el-input__clear::after {
        //对应图标
        background: url("../../assets/images/icon-js-gb.png") 100%/100%;
        position: absolute;
        content: " ";
        display: block;
        width: 15px;
        height: 15px;
        top: 50%;
        margin-top: -7.5px;
        content: " ";
      }
    }
  }
  ::v-deep .el-dialog__header {
    background: #2d8cf0;
    height: 46px;
    line-height: 46px;
    padding: 0;
    padding-left: 30px;
    font-size: 18px;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      right: 15px;
      top: 12px;
      .el-dialog__close {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: left;
    padding-top: 0;
    padding-bottom: 30px;
    .down-dialog-footer {
      span {
        width: 80px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        margin-left: 10px;
        cursor: pointer;
        background: #f0f7f7;
        color: #2d8cf0;
        &:hover {
          background: #2d8cf0;
          color: #fff;
        }
      }
    }
  }
  .add_folder_dialog {
    ::v-deep .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      p {
        padding-left: 20px;
        cursor: pointer;
        i {
          margin-right: 5px;
        }
      }
    }
  }
  .dialog-content {
    .dialog-tab {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      li {
        padding-right: 10px;
        position: relative;
        padding: 0 10px;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .dialogChecked {
        color: #2d8cf0;
        &::before {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          height: 2px;
          background: #2d8cf0;
          width: 100%;
        }
      }
    }
    .tab1 {
      margin-top: 20px;
      ul {
        max-height: 500px;
        overflow: auto;
        li {
          background: #f7f7f7;
          padding: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 8px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }

      .flex {
        align-items: center;

        span {
          margin-left: auto;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d8cf0;
        }
      }
      .line {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        label {
          color: #333;
          font-weight: bold;
        }
      }
      img {
        width: 17px;
        height: 16px;
        margin-right: 5px;
      }
      .dialog-info {
        color: #333333;
        line-height: 30px;
        margin-top: 20px;
        font-size: 16px;
        white-space: pre-wrap;
      }
    }
  }
}

.add_dialog_folder {
  max-height: 400px;
  overflow-y: auto;
  ul {
    li {
      cursor: pointer;
      color: #333;
      .div_folder {
        height: 40px;
        border-radius: 5px;
        display: flex;
        padding: 0 20px;
        align-items: center;
      }
      .li_folder {
        justify-content: space-between;
        border: 1px solid #fff;
      }
      .new_folder {
        border: 1px solid #2d8cf0;
        ::v-deep .el-input__inner {
          border: none;
          background: none;
          height: 25px;
          color: #333;
          padding: 0;
        }
        span {
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          font-size: 16px;
          margin-left: 10px;
          i {
            color: #868686;
          }
        }
      }
      &:hover {
        background: #f5f6f7;
      }
      img {
        margin-right: 10px;
      }
      i {
        color: #2d8cf0;
        font-size: 18px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #2d8cf0;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}
::v-deep .el-dialog__footer .dialog-footer {
  text-align: right;
  display: block;
}

::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

@media (max-width: 1440px) {
  .container .w1580 {
    flex-direction: column;

    .right-list,
    .topicList {
      width: 100%;
    }

    .topicList {
      margin: 12px 0 0;

      h3 {
        width: 100%;
      }

      ul {
        min-height: 0;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px 24px;

        li {
          min-width: 0;
          margin-bottom: 0;
        }
      }
    }
  }

  ::v-deep .container_menu {
    width: 100%;
    max-width: none;
    min-height: 0;
    margin-right: 0;
    margin-bottom: 12px;

    .menu .menu-list {
      max-height: 280px;
    }
  }
}

@media (max-width: 768px) {
  .container {
    .article-search {
      height: auto;
      min-height: 220px;
      padding: 24px 0 12px;

      .search-wapper {
        width: calc(100% - 24px);
      }

      h3 {
        font-size: 21px;
        line-height: 1.5;
      }

      .search .search_div {
        align-items: stretch;
        flex-direction: column;
        width: 100%;
        margin-top: 20px;

        .title-select {
          width: 100%;
          margin: 0 0 8px;

          ::v-deep .el-input__inner {
            height: 42px;
          }
        }

        > a {
          align-self: flex-end;
          margin: 10px 0 0;
          font-size: 14px;
        }

        .search-height {
          top: 104px;
          left: 0;
          width: 100%;
          padding: 14px;

          > .flex {
            align-items: stretch;
            flex-direction: column;

            ::v-deep .el-select,
            ::v-deep .el-input {
              width: 100%;
              margin: 0 0 8px;
            }
          }

          .time-height {
            display: grid;
            grid-template-columns: 1fr auto 1fr auto;
            align-items: center;
            gap: 8px;

            .el-date-editor,
            ::v-deep .el-input__inner {
              width: 100%;
            }
          }

          .btns-height {
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 10px;

            span {
              margin-right: 10px;
            }

            .btns {
              width: 100%;
              margin-left: 0;
              text-align: right;
            }
          }
        }
      }

      .search .searchLeft {
        width: 100%;
        height: 44px;

        ::v-deep .el-input__inner {
          height: 42px;
        }

        .inputDiv .search-btn {
          width: 52px;
          height: 36px;
        }

        .search-input {
          top: 44px;
        }
      }

      .search_nav {
        position: static;
        margin-top: 12px;
      }
    }

    .w1580 {
      width: calc(100% - 24px);
      margin-top: 12px;
      margin-bottom: 16px;

      .right-list {
        .filter {
          align-items: flex-start;
          padding: 12px;
          gap: 8px;

          .flex {
            margin-right: 0;
            overflow-wrap: anywhere;
          }
        }

        .right-item {
          .sort-item {
            align-items: center;
            overflow-x: auto;
            padding: 16px 12px 12px;

            > p {
              flex: 0 0 auto;
              margin-right: 22px;
              white-space: nowrap;

              &:hover::before {
                bottom: -16px;
              }
            }

            .checked::before {
              bottom: -16px;
            }

            .pagination-controls {
              flex: 0 0 auto;
            }
          }

          > ul {
            padding: 0 12px;

            > li {
              padding: 16px 0;

              > .index {
                width: 32px;
                flex: 0 0 32px;
              }

              .right-info {
                > p {
                  line-height: 24px;
                  overflow-wrap: anywhere;

                  &:nth-of-type(1) {
                    font-size: 16px;
                  }
                }

                .btn-p {
                  align-items: flex-start;
                  flex-direction: column;
                  gap: 10px;
                  margin-top: 16px;
                }

                .btn-right {
                  width: 100%;
                  margin-left: 0;
                  flex-wrap: wrap;
                  gap: 10px 18px;

                  .flex {
                    margin-left: 0;
                  }
                }

                .author-content {
                  left: 0;
                  right: auto;
                  min-width: 0;
                  width: min(300px, calc(100vw - 72px));
                  box-sizing: border-box;
                }
              }

              .achieve {
                left: 0;
                right: auto;
                max-width: calc(100vw - 72px);

                .achieve-li {
                  min-width: 0;
                  max-width: 100%;
                  box-sizing: border-box;
                }
              }
            }
          }
        }
      }

      .topicList ul {
        grid-template-columns: 1fr;
        padding: 14px;
      }
    }
  }

  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
    white-space: normal;

    .el-pagination__sizes,
    .el-pagination__jump {
      margin-left: 0;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 18px 16px 30px;
  }
}

@media (max-width: 480px) {
  .container .w1580 .right-list .right-item > ul > li > .index {
    display: none;
  }

  ::v-deep .el-pagination {
    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump {
      display: none;
    }
  }
}
</style>
